import React, { useEffect, useState } from "react";
import {
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import {
  SchoolOutlined,
  HomeOutlined,
  BadgeOutlined,
  ScreenSearchDesktopOutlined,
  KeyOutlined,
  NewspaperOutlined,
  DriveFileMove,
} from "@mui/icons-material";
import * as storage from "app/data/storage";
import { useQuery } from "@tanstack/react-query";
import { fetchGoogleDriveUrl } from "app/services/userServices/user";
import { getContactInfo } from "app/services/profileServices/Profile";
import { getInstitutionInfo } from "app/services/profileServices/Profile";
import { MatxLoading } from "app/components";
import { set } from "lodash";

const selectedUserRole = storage.get("role") === "GUEST" ? true : false;

const Sidebar = ({ setSelectedProfileItem, selectedProfileItem }) => {

  const [userContactInfo, setUserContactInfo] = useState({});
  const [institutionInfo, setInstitutionInfo] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);

  const { data: driveUrl } = useQuery({
    queryKey: ["googleDriveUrl"],
    queryFn: async () => {
      const data = await fetchGoogleDriveUrl();
      return data.data.response;
    },
  });
  const fetchContactInfo = async () => {
    const data = await getContactInfo();
    setUserContactInfo(data.data.response);

    if(!data.data.response){
      setSelectedProfileItem("profileUserAddress");
    }
  };

  const fetchInstitutionInfo = async () => {
    const data = await getInstitutionInfo();
    setInstitutionInfo(data.data.response);
  };

  const fetchData = async () => {
    await fetchContactInfo();
    await fetchInstitutionInfo();
    setIsLoading(false);
  };

  useEffect(() => {
    setSelectedProfileItem("");
    fetchData();
  }, []);

  
  const menuItems = [
    {
      text: "Informações de Contato",
      action: "profileUserAddress",
      icon: <HomeOutlined />,
    },
    {
      text: "Instituição",
      action: "profileInstituition",
      icon: <SchoolOutlined />,
      disabled: !!!userContactInfo,
    },
    { text: "Meus Perfis", 
      action: "profileSelect", 
      icon: <BadgeOutlined />,
      disabled: !institutionInfo?.userInstitution?.department_id,
    },
    {
      text: "Projeto de Pesquisa",
      action: "profileProject",
      icon: <ScreenSearchDesktopOutlined />,
      disabled: selectedUserRole,
    },
    {
      text: "Publicações",
      action: "profilePublish",
      icon: <NewspaperOutlined />,
      disabled: selectedUserRole,
    },
    {
      text: "Alterar Senha",
      action: "profileChangePassword",
      icon: <KeyOutlined />,
      disabled: selectedUserRole,
    },
    {
      text: "Google Drive",
      action: "getGoogleDriveURL",
      icon: <DriveFileMove />,
      disabled: selectedUserRole || !driveUrl,
      href: driveUrl?.link || "",
    },
  ];

  if(isLoading){
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20vh" }}>
        <MatxLoading />
      </div>
    )
  }

  return (
    <List>
      {menuItems.map((item, index) => (
        <ListItemButton
          key={item.text}
          onClick={() =>
            item.href
              ? window.open(item.href, "_blank")
              : setSelectedProfileItem(item.action)
          }
          disabled={item.disabled}
          selected={selectedProfileItem === item.action}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      ))}
    </List>
  );
};

export default Sidebar;
